import { ChipProps } from '@mui/material';
import { DateTime } from 'luxon';
import {
  DailyReportCardLayout,
  DailyReportItem,
  SaveInspectionModal
} from 'modules/components';
import React, { useState } from 'react';



export type ReportInspectionCardProps = {
  id: string;
  inspections: {
    id: string;
    createdAt: DateTime;
    inspectedSystem: string;
    dateInspected: DateTime | null;
    inspectedByName: string;
    description: string;
    inspectionResult: {
      name: string;
      displayName: string;
    };
  }[];
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ReportInspectionCardProps) => {

  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  return (
    <> {
      isVisible && (
        <SaveInspectionModal.FC
          id=''
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )
    }
    <DailyReportCardLayout.FC
      title='Inspections'
      subTitle='Events when building site was being checked by authorities.'
      actionButton={{
        text: 'Add new Inspection',
        onClick: () => {
          setIsVisible(() => true);
        }
      }}
    >
      {
        props.inspections.map((node) => (
          <DailyReportItem.FC
            key={node.id}
            id={node.id}
            details={{
              type: 'INSPECTION',
              description: node.description,
              inspectionResultDisplayName: node.inspectionResult.displayName,
              inspectionResultName: node.inspectionResult.name as ChipProps['variant'],
              systemName: node.inspectedSystem
            }}
            reportItemType='INSPECTION'
          />
        ))
      }
    </DailyReportCardLayout.FC>
    </>
  );
};
